import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormField, Select, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { listDataZoneEntities } from 'src/api/permissions';
import { CartAccessItem } from 'src/components/common/checkout/common';
import { isValidWorkspace } from 'src/commons/validationUtils';
import { getFoundryRoleARN } from 'src/commons/common';
import { RESOURCE_ITEM } from 'src/commons/constants';
import { IdInfo } from 'src/components/utils/arnUtil';
import { PermissionDropdownOption } from 'src/components/catalog/datasetdetail/datasetDetailHelpers';

export interface DataZoneAccessSelectorProps {
  activeGroup: string;
  activeWorkspace?: any;
  permissionOption: PermissionDropdownOption;
  idInfo: IdInfo;
  loading: any;
  setCartItemsToAdd: any;
}

export const DataZoneAccessSelector = (props: DataZoneAccessSelectorProps) => {
  const [options, setOptions] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState<any>(undefined);

  const handleRefresh = async () => {
    const listDataZoneEntitiesResult = await listDataZoneEntities({
      groupId: props.activeGroup,
      entityType: 'Project',
    });
    setOptions(
      listDataZoneEntitiesResult.entities.map((entity) => ({
        label: entity.groupId,
        value: entity.projectId,
      })),
    );
  };

  useEffect(() => {
    handleRefresh();
  }, []);

  const flattenDataZoneDatasetAccess = (item): CartAccessItem => {
    return {
      datasetName: item.datasetName,
      databaseName: item.databaseName,
      tableName: item.datasetName,
      catalogId: item.catalogId,
      region: props.idInfo.region,
      catalogDisplayName: item.catalogName,
      dataOwnerRole: isValidWorkspace(item.owner)
        ? getFoundryRoleARN(props.idInfo.region, item.catalogId)
        : item.publisherRole,
      owner: item.owner,
      itemType: RESOURCE_ITEM,
      permissionId: item.permissionId,
      catalogName: item.catalogName,
      id: item.id,
      dataLakePrincipal: props.activeWorkspace.accountId,
      // DZ fields
      dataZoneAssetId: item.dataZoneAssetId,
      dataZoneConsumerProjectId: selectedOption?.value,
      clusterId: item.clusterId,
      redshiftWorkgroupName: item.redshiftWorkgroupName,
      schemaName: item.schemaName,
    };
  };

  const handleChange = (e) => {
    setSelectedOption(e.detail.selectedOption);
  };

  useEffect(() => {
    if (!!selectedOption) {
      let ds = flattenDataZoneDatasetAccess(props.permissionOption);
      props.setCartItemsToAdd([ds]);
    }
  }, [selectedOption]);

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <FormField label='Consumer project' description={'Select which DataZone project to request for.'}>
        <Select
          selectedOption={selectedOption}
          options={options}
          onChange={handleChange}
          statusType={props.loading ? 'loading' : 'finished'}
          loadingText='Loading projects'
        />
      </FormField>
    </SpaceBetween>
  );
};
